module.exports = __webpack_public_path__ + "static/media/karen_tan.8846d611.png";